import { createStore, applyMiddleware } from "redux";
import { persistStore, PersistedState } from "redux-persist";
import { logger } from "redux-logger";
import thunk from "redux-thunk";
import localforage from "localforage";
import { routerMiddleware } from "connected-react-router";
import { history } from "./myhistory";

import allReducers, { ApplicationState } from "./reducers/Index";
import { INITIAL_APP_STATE } from "./reducers/InitialAppState";

//Init middlewares
const middleware = [
    thunk,
    routerMiddleware(history)
]

//Conditionally add the logger middlware only in the development environment
if (process.env.NODE_ENV === "development") {
   // middleware.push(logger);
}

const rootReducer = (state, action) => {

    //clear persisted storage when user logs out
    if (action.type === "LOGOUT") {
        localforage.clear();
        return allReducers(state = INITIAL_APP_STATE, action);
    }

    return allReducers(state, action);

}

export const store = createStore(rootReducer, applyMiddleware(...middleware));

export const persistor = persistStore(store)